import { render, staticRenderFns } from "./AppLogs.vue?vue&type=template&id=60dd5d26&scoped=true"
import script from "./AppLogs.vue?vue&type=script&lang=js"
export * from "./AppLogs.vue?vue&type=script&lang=js"
import style0 from "./AppLogs.vue?vue&type=style&index=0&id=60dd5d26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dd5d26",
  null
  
)

export default component.exports